import { render } from "./Questionnaire.vue?vue&type=template&id=b63d484e&scoped=true&ts=true"
import script from "./Questionnaire.vue?vue&type=script&lang=ts"
export * from "./Questionnaire.vue?vue&type=script&lang=ts"

import "./Questionnaire.vue?vue&type=style&index=0&id=b63d484e&scoped=true&lang=scss"

import exportComponent from "/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b63d484e"]])

export default __exports__